

export default {
    name: 'Radio',
    components: {
    },
    model: {
        event: 'change',
        prop: 'modelValue'
    },
    props: {
        value: {
            required: true
        },
        modelValue: {
            type: null,
            default: null
        },
        checked: {
            type: Boolean,
            defaulf: false
        },
        size: {
            type: String,
            default: 'sm',
            validator: val => ['sm', 'md'].includes(val)
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isChecked () {
            return this.modelValue === this.value
        }
    }
}
